import { AxiosError, AxiosResponse } from "axios"
import api from "../../../data/api"
import { Dispatch } from "react"
import { prepareError, prepareErrorFromArray } from "../../../utils/error"
import { objectFormData } from "../../../utils/formdata"
import { CCBAction } from "../results/reducer"
import {SearchHistoryAction} from "../../../components/app/reducer"
import { CCB } from "../../../openapi/ccb/api"



// search for ismag issuers
export const fetchCcbs = (
    dispatch: Dispatch<CCBAction>,
    dispatchHistory: Dispatch<SearchHistoryAction>,
    data: FormData,
    ccbSearchHistory: Object
) => {
    //console.log("CCB criteria service search for issuers using params")
    //alert("Searching:" + stringifyFormData( data));
    // console.log( "sending data " + JSON.stringify(objectFormData(data)) )
    dispatchHistory({type: "SearchHistory", searchHistory: ccbSearchHistory});
    api
        .post("/codelist/v1/ccb/search",  objectFormData(data)  )
        .then( (response:AxiosResponse) => {

            if ( response.data.result && response.data.result === "ERROR") {
                dispatch({ type: "CCB/FETCHERROR", payload: prepareErrorFromArray(response.data.errorMessage, "Error") })
            } else if ( response.data.result && response.data.result === "REJECTED" ){
                dispatch({ type: "CCB/FETCHERROR", payload: "For selected search criteria no data has been found."})
            } else { 
                // console.log("ccb query service: got data " + JSON.stringify(response, null, 2))
                const ccbs : CCB[] = response.data.CCB; 
               // console.log( "Ccb criteria service -> fetchCcb::dispatching " + JSON.stringify( ccbs, null, 2))
                dispatch({type: "CCB/SEARCHDONE", payload: ccbs, searchCriteria: data });
                dispatch({ type: "CCB/FETCHERROR", payload: ""});                
            }
        }).catch( (error:AxiosError) => {
            dispatch({ type: "CCB/FETCHERROR", payload: prepareError(error) })
        })


}
